export default __webpack_public_path__ + "static/media/social-linkedin.3ab0008f.svg";